import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const appEnv = ((import.meta as any).env.APP_ENV ?? import.meta.env.VITE_APP_ENV ?? "development") as string;
const sentryRelease = ((import.meta as any).env.SENTRY_RELEASE ?? undefined) as string | undefined;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: appEnv,
    release: sentryRelease,
    tracesSampleRate: 0.1,
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
    <App />
  </Sentry.ErrorBoundary>
);
